import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { toTypeScriptType } from '@core-engine/schema/type-mappers/typescript/to-type-script-type.js'
export function getFieldType(field: SchemaField, mode: 'input' | 'output' = 'output'): string {
  return toTypeScriptType(field, mode)
}
